export const referrerMessages = {
  "zh_hans": {
    "registration.referrerLabel": "推荐人（选填）",
    "registration.referrerPlaceholder": "用户ID、昵称、账号或手机号",
    "registration.referrerSearch": "查找推荐人",
    "registration.referrerSearching": "正在查找推荐人…",
    "registration.referrerSelected": "已选择：{name}（ID：{id}）",
    "registration.referrerSelectTitle": "选择推荐人",
    "registration.referrerMultiple": "找到多个用户，请选择一个推荐人。",
    "registration.referrerNotFound": "找不到该推荐人，请检查输入或留空。",
    "registration.referrerTooMany": "匹配用户过多，请使用用户ID或账号查找。",
    "registration.referrerCancel": "取消"
  },
  "zh_hant": {
    "registration.referrerLabel": "推薦人（選填）",
    "registration.referrerPlaceholder": "使用者ID、暱稱、帳號或手機號",
    "registration.referrerSearch": "查找推薦人",
    "registration.referrerSearching": "正在查找推薦人…",
    "registration.referrerSelected": "已選擇：{name}（ID：{id}）",
    "registration.referrerSelectTitle": "選擇推薦人",
    "registration.referrerMultiple": "找到多個使用者，請選擇一位推薦人。",
    "registration.referrerNotFound": "找不到此推薦人，請檢查輸入或留空。",
    "registration.referrerTooMany": "符合的使用者太多，請用使用者ID或帳號查找。",
    "registration.referrerCancel": "取消"
  },
  "en": {
    "registration.referrerLabel": "Referrer (optional)",
    "registration.referrerPlaceholder": "User ID, nickname, account or phone",
    "registration.referrerSearch": "Find referrer",
    "registration.referrerSearching": "Finding referrer…",
    "registration.referrerSelected": "Selected: {name} (ID: {id})",
    "registration.referrerSelectTitle": "Choose a referrer",
    "registration.referrerMultiple": "Multiple users found. Choose one referrer.",
    "registration.referrerNotFound": "Referrer not found. Check your entry or leave it blank.",
    "registration.referrerTooMany": "Too many matches. Search by user ID or account.",
    "registration.referrerCancel": "Cancel"
  },
  "lo": {
    "registration.referrerLabel": "ຜູ້ແນະນຳ (ບໍ່ບັງຄັບ)",
    "registration.referrerPlaceholder": "ID ຜູ້ໃຊ້, ຊື່ຫຼິ້ນ, ບັນຊີ ຫຼື ເບີໂທ",
    "registration.referrerSearch": "ຄົ້ນຫາຜູ້ແນະນຳ",
    "registration.referrerSearching": "ກຳລັງຄົ້ນຫາຜູ້ແນະນຳ…",
    "registration.referrerSelected": "ເລືອກແລ້ວ: {name} (ID: {id})",
    "registration.referrerSelectTitle": "ເລືອກຜູ້ແນະນຳ",
    "registration.referrerMultiple": "ພົບຜູ້ໃຊ້ຫຼາຍຄົນ. ກະລຸນາເລືອກຜູ້ແນະນຳໜຶ່ງຄົນ.",
    "registration.referrerNotFound": "ບໍ່ພົບຜູ້ແນະນຳ. ກວດຂໍ້ມູນ ຫຼື ປ່ອຍວ່າງ.",
    "registration.referrerTooMany": "ພົບຫຼາຍເກີນໄປ. ຄົ້ນຫາດ້ວຍ ID ຫຼື ບັນຊີ.",
    "registration.referrerCancel": "ຍົກເລີກ"
  },
  "km": {
    "registration.referrerLabel": "អ្នកណែនាំ (មិនចាំបាច់)",
    "registration.referrerPlaceholder": "ID អ្នកប្រើ ឈ្មោះហៅក្រៅ គណនី ឬលេខទូរស័ព្ទ",
    "registration.referrerSearch": "ស្វែងរកអ្នកណែនាំ",
    "registration.referrerSearching": "កំពុងស្វែងរកអ្នកណែនាំ…",
    "registration.referrerSelected": "បានជ្រើសរើស៖ {name} (ID: {id})",
    "registration.referrerSelectTitle": "ជ្រើសរើសអ្នកណែនាំ",
    "registration.referrerMultiple": "រកឃើញអ្នកប្រើច្រើន។ សូមជ្រើសរើសអ្នកណែនាំម្នាក់។",
    "registration.referrerNotFound": "រកមិនឃើញអ្នកណែនាំ។ ពិនិត្យទិន្នន័យ ឬទុកចោល។",
    "registration.referrerTooMany": "មានលទ្ធផលច្រើនពេក។ ស្វែងរកតាម ID ឬគណនី។",
    "registration.referrerCancel": "បោះបង់"
  },
  "th": {
    "registration.referrerLabel": "ผู้แนะนำ (ไม่บังคับ)",
    "registration.referrerPlaceholder": "ID ผู้ใช้ ชื่อเล่น บัญชี หรือเบอร์โทร",
    "registration.referrerSearch": "ค้นหาผู้แนะนำ",
    "registration.referrerSearching": "กำลังค้นหาผู้แนะนำ…",
    "registration.referrerSelected": "เลือกแล้ว: {name} (ID: {id})",
    "registration.referrerSelectTitle": "เลือกผู้แนะนำ",
    "registration.referrerMultiple": "พบผู้ใช้หลายคน กรุณาเลือกผู้แนะนำหนึ่งคน",
    "registration.referrerNotFound": "ไม่พบผู้แนะนำ ตรวจสอบข้อมูลหรือเว้นว่างไว้",
    "registration.referrerTooMany": "พบผู้ใช้มากเกินไป กรุณาค้นหาด้วย ID หรือบัญชี",
    "registration.referrerCancel": "ยกเลิก"
  },
  "vi": {
    "registration.referrerLabel": "Người giới thiệu (không bắt buộc)",
    "registration.referrerPlaceholder": "ID người dùng, biệt danh, tài khoản hoặc số điện thoại",
    "registration.referrerSearch": "Tìm người giới thiệu",
    "registration.referrerSearching": "Đang tìm người giới thiệu…",
    "registration.referrerSelected": "Đã chọn: {name} (ID: {id})",
    "registration.referrerSelectTitle": "Chọn người giới thiệu",
    "registration.referrerMultiple": "Tìm thấy nhiều người dùng. Hãy chọn một người giới thiệu.",
    "registration.referrerNotFound": "Không tìm thấy người giới thiệu. Kiểm tra thông tin hoặc để trống.",
    "registration.referrerTooMany": "Có quá nhiều kết quả. Tìm bằng ID hoặc tài khoản.",
    "registration.referrerCancel": "Hủy"
  }
};
